import React from "react";
import styles from "gui/BrowseDashboardsPage/BrowsePage.module.css";
import { EntriesRequestFilters } from "lib/entries/types";
import { FieldLabel } from "gui/input/fields";
import { InputText } from "gui/input/input";

export const BrowseUsersSearch: React.FC<{
  entriesRequestFilters: EntriesRequestFilters;
  setEntriesRequestFilters: (
    entriesRequestFilters: EntriesRequestFilters
  ) => void;
}> = (props) => {
  const onQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setEntriesRequestFilters({
      ...props.entriesRequestFilters,
      page: 1,
      q: event.target.value,
    });
  };

  return (
    <aside className={styles.searchOptions}>
      <FieldLabel label="Search for wizards">
        <InputText
          placeholder="Name..."
          autoComplete="off"
          type="search"
          value={props.entriesRequestFilters.q ?? ""}
          onChange={onQuery}
        />
      </FieldLabel>
    </aside>
  );
};
